
function formatKey(key) {
  return key
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export async function insertCRFDataIntoWordAtPage(pageIndex, data) {
  return Word.run(async (context) => {

    const body = context.document.body;
    const tag = `CRF_PAGE_${pageIndex}`;

    // Load existing controls
    const controls = context.document.contentControls.getByTag(tag);
    context.load(controls, "items");

    // Needed to detect existing FORM
    const paragraphs = body.paragraphs;
    context.load(paragraphs, "items/style,items/text");

    await context.sync();

    let cc;
    if (controls.items.length === 0) {

      if (pageIndex !== 0) {
        body.insertBreak("Page", Word.InsertLocation.end);
      }

      const para = body.insertParagraph("", Word.InsertLocation.end);
      cc = para.insertContentControl();
      cc.tag = tag;
      cc.title = `CRF Page ${pageIndex + 1}`;

    } else {
      cc = controls.items[0];
      cc.clear();
    }

    // word navigation
    let formAlreadyExists = false;

    for (const p of paragraphs.items) {
      if (p.style === "Heading 1" && p.text.trim() === data.form) {
        formAlreadyExists = true;
        break;
      }
    }

    if (!formAlreadyExists) {

      const formHeading = cc.insertParagraph(
        data.form,
        Word.InsertLocation.start
      );

      formHeading.style = "Heading 1";
      formHeading.font.size = 1;
      formHeading.font.color = "white";

      const epochHeading = formHeading.insertParagraph(
        data.epoch,
        Word.InsertLocation.after
      );

      epochHeading.style = "Heading 2";
      epochHeading.font.size = 1;
      epochHeading.font.color = "white";
      epochHeading.select();

    } else {

      const epochHeading = cc.insertParagraph(
        data.epoch,
        Word.InsertLocation.start
      );

      epochHeading.style = "Heading 2";
      epochHeading.font.size = 1;
      epochHeading.font.color = "white";
      epochHeading.select();
    }

    for (const [key, value] of Object.entries(data)) {

      if (key === "fields") continue;

      if (key === "note") {

        const notePara = cc.insertParagraph(
          `${formatKey(key)}: ${value}`,
          Word.InsertLocation.end
        );

        notePara.font.color = "#426bba";
        notePara.font.italic = true;

        const resetPara = cc.insertParagraph("", Word.InsertLocation.end);
        resetPara.font.color = "black";

      } else {

        const para = cc.insertParagraph(
          `${formatKey(key)}: ${value}`,
          Word.InsertLocation.end
        );

        para.font.bold = true; // metadata stays bold
        para.font.color = "black";
        para.alignment = Word.Alignment.left;
      }
    }

    cc.insertParagraph(
      "____________________________________________________________________________________",
      Word.InsertLocation.end
    );

    for (const field of data.fields || []) {

      const labelPara = cc.insertParagraph(
        field.field_label,
        Word.InsertLocation.end
      );

      labelPara.alignment = Word.Alignment.left;
      labelPara.font.bold = false; // ensure label not bold

      const fieldValue = field.field_value;
      const options = field.field_options || [];

      if (options.length > 0) {

        for (const opt of options) {

          const checked = Array.isArray(fieldValue)
            ? fieldValue.includes(opt)
            : fieldValue === opt;

          const checkbox = checked ? "▣" : "☐";

          const optPara = cc.insertParagraph(
            `   ${checkbox} ${opt}`,
            Word.InsertLocation.end
          );

          optPara.alignment = Word.Alignment.right;
          optPara.font.bold = false; // ensure checkbox text not bold
        }

      } else {

        const valPara = cc.insertParagraph(
          "   " + (fieldValue || ""),
          Word.InsertLocation.end
        );

        valPara.alignment = Word.Alignment.right;
        valPara.font.bold = false; // ensure value not bold

        if (field.field_unit && field.field_unit !== "None") {

          const unitPara = cc.insertParagraph(
            `Fixed Unit: ${field.field_unit}`,
            Word.InsertLocation.end
          );

          unitPara.alignment = Word.Alignment.right;
          unitPara.font.bold = false; // ensure unit not bold
        }
      }

      cc.insertParagraph(
        "____________________________________________________________________________________",
        Word.InsertLocation.end
      );
    }

    await context.sync();
  });
}





 